module.exports = __webpack_public_path__ + "img/莪术.61a1bdee.jpg";